import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from '../../models/menu-item.model';
import { HorizontalMenuItemComponent } from '../horizontal-menu-item/horizontal-menu-item.component';

@Component({
  selector: 'app-horizontal-menu',
  imports: [HorizontalMenuItemComponent],
  templateUrl: './horizontal-menu.component.html',
  styleUrl: './horizontal-menu.component.scss'
})
export class HorizontalMenuComponent {
  @Input({ required: true }) items: MenuItem[] = [];
  @Input() selectedIndex = 0;
  @Output() itemSelected = new EventEmitter<number>();

  protected getTone(label: string): 'default' | 'stocks' | 'magenta' | 'green' {
    const normalized = (label || '').trim().toLowerCase();
    if (
      normalized === 'gestion des stocks' ||
      normalized === 'lignes de commandes'
    ) {
      return 'stocks';
    }
    if (
      normalized === 'gestion du pipe' ||
      normalized === 'gestion des données' ||
      normalized === 'gestion des rapports'
    ) {
      return 'green';
    }
    if (
      normalized === 'gestion des logistiques' ||
      normalized === 'gestion client' ||
      normalized === 'gestion des clients' ||
      normalized === 'gestion des commandes'
    ) {
      return 'magenta';
    }
    return 'default';
  }
}
